import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    minHeight: '100vh',
    '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
    background: '#f2f5f6',
    color: '#263d48',
  },
  header: { position: 'fixed', width: '100%', zIndex: theme.zIndex.appBar },
  body: { padding: '88px 24px 32px', maxWidth: 1440, margin: '0 auto',
    [theme.breakpoints.down('sm')]: { padding: '80px 12px 24px' } },
  introduction: { marginBottom: 16 },
  title: { fontWeight: 600, fontSize: 24 },
  muted: { color: '#586d78' },
  panel: { padding: 16, marginBottom: 16, border: '1px solid #d7e1e5',
    boxShadow: 'none', borderRadius: 8 },
  filters: { display: 'grid', gridTemplateColumns: 'minmax(220px, 2fr) minmax(180px, 1fr) auto', gap: 12, alignItems: 'center',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' } },
  actions: { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' },
  moreFilters: { marginTop: 14,
    '& summary': { cursor: 'pointer', color: '#36596b', fontSize: 13, fontWeight: 600, width: 'fit-content', padding: '4px 0' },
    '& summary:focus-visible': { outline: '2px solid #527b8e', outlineOffset: 4 },
  },
  secondaryFilters: { display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12, alignItems: 'center', paddingTop: 14,
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' } },
  filterState: { marginTop: 12, fontSize: 13 },
  metadata: { display: 'flex', gap: '4px 18px', flexWrap: 'wrap', margin: '8px 0 14px', color: '#586d78',
    '& > *': { overflowWrap: 'anywhere' } },
  toolbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left',
    '& th': { background: '#e8f0f3', color: '#3d5967', fontSize: 12, fontWeight: 600 },
    '& th, & td': { padding: '11px 12px', verticalAlign: 'middle', borderBottom: '1px solid #d7e1e5' },
    '& td': { overflowWrap: 'anywhere', fontSize: 14 },
    '& tbody tr:hover': { background: '#f2f6f7' },
    [theme.breakpoints.down('sm')]: {
      '&, & tbody, & tr, & td': { display: 'block', width: '100%', boxSizing: 'border-box' },
      '& thead': { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)' },
      '& tr': { padding: '10px 0', borderBottom: '1px solid #d7e1e5' },
      '& td': { borderBottom: 'none', padding: '5px 8px', display: 'grid', gridTemplateColumns: '110px minmax(0, 1fr)', gap: 8 },
      '& td::before': { content: 'attr(data-label)', display: 'block', fontSize: 12, fontWeight: 600, color: '#586d78' },
    },
  },
  name: { fontWeight: 600 },
  phone: { color: '#36596b', textDecoration: 'underline', textUnderlineOffset: 3,
    '&:focus-visible': { outline: '2px solid #527b8e', outlineOffset: 3 } },
  state: { padding: '28px 12px', textAlign: 'center', color: '#586d78', '& button': { marginTop: 12 } },
  pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, paddingTop: 12, flexWrap: 'wrap' },
}));